import React, { useState, useEffect } from "react";
import Card from "../components/card/Card.jsx";
import nft from "../assets/img/nft.png";
import nft2 from "../assets/img/nft2.png";
import topleft from "../assets/img/topleft.png";
import Footer from "../components/footer/Footer.jsx";

export default function Home() {
  const [currentPage, setCurrentPage] = useState("playlist");

  const changePage = (val) => {
    setCurrentPage(val);
  };

  return (
    <div className="home-wrapper">
      <div className="price">
        <div>
          <div style={{ marginBottom: "4px" }}> 1 Music = $USD 0.452</div>
          <div> 1 BNB = $USD 0.452 </div>
        </div>
      </div>

      <div>
        <div className="home-links">
          <div
            className={`playlist ${
              currentPage === "playlist" ? "highlight" : ""
            }`}
            onClick={() => changePage("playlist")}
          >
            PLAYLIST
          </div>
          <div
            className={`nftlist ${currentPage === "nft" ? "highlight" : ""}`}
            onClick={() => changePage("nft")}
          >
            NFT
          </div>
        </div>
      </div>

      <div className="first-row-wrapper">
        <div className="first-header">Just For You</div>

        <div className="first-row">
          <div className="each-card">
            <Card image={nft} type={"bid"} />
          </div>
          <div className="each-card">
            <Card image={nft2} type={"bid"} />
          </div>
          <div className="each-card">
            <Card image={nft} type={"direct"} />
          </div>
          <div className="each-card">
            <Card image={nft} type={"bid"} />
          </div>
          <div className="each-card">
            <Card image={nft2} type={"direct"} />
          </div>
          <div className="each-card">
            <Card image={nft} type={"direct"} />
          </div>
          <div className="each-card">
            <Card image={nft2} type={"bid"} />
          </div>
        </div>
      </div>
      <div className="first-row-wrapper">
        <div className="first-header">Recently added</div>

        <div className="first-row">
          <div className="each-card">
            <Card image={nft} type={"bid"} />
          </div>
          <div className="each-card">
            <Card image={nft2} type={"bid"} />
          </div>
          <div className="each-card">
            <Card image={nft} type={"direct"} />
          </div>
          <div className="each-card">
            <Card image={nft} type={"bid"} />
          </div>
          <div className="each-card">
            <Card image={nft2} type={"direct"} />
          </div>
          <div className="each-card">
            <Card image={nft} type={"direct"} />
          </div>
          <div className="each-card">
            <Card image={nft2} type={"bid"} />
          </div>
        </div>
      </div>
      <div className="first-row-wrapper">
        <div className="first-header">Most Popular</div>

        <div className="first-row">
          <div className="each-card">
            <Card image={nft} type={"bid"} />
          </div>
          <div className="each-card">
            <Card image={nft2} type={"bid"} />
          </div>
          <div className="each-card">
            <Card image={nft} type={"direct"} />
          </div>
          <div className="each-card">
            <Card image={nft} type={"bid"} />
          </div>
          <div className="each-card">
            <Card image={nft2} type={"direct"} />
          </div>
          <div className="each-card">
            <Card image={nft} type={"direct"} />
          </div>
          <div className="each-card">
            <Card image={nft2} type={"bid"} />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
